"use strict"

import angular from "angular"
import { Wgs84, UtmK } from "common-library/geocode"

angular.module("uCountitUiApp").service("GeocodeSrv", function ($window, ApiSrv) {
  return {
    openAddressPopup: function (roadNameAPIKey, callback) {
      const baseUrl = "https://business.juso.go.kr/addrlink/addrLinkUrl.do"
      const returnUrl = new URL($window.location.href)
      returnUrl.pathname = "/api/geocode/address/return"
      const url =
        `${baseUrl}?confmKey=${encodeURIComponent(roadNameAPIKey)}` +
        `&returnUrl=${encodeURIComponent(returnUrl.toString())}`

      const pop = $window.open(url, "jusoPop", "width=570,height=420,scrollbars=yes,resizable=yes")
      if (!pop) {
        return
      }

      // NOTE: Juso API 사용 가능 변수 목록 - https://business.juso.go.kr/addrlink/openApi/popupApi.do
      $window.jusoCallback = function (data) {
        if (callback && typeof callback === "function") {
          callback({
            address: data.roadAddrPart1,
            ...data,
          })
        }
        if (pop && !pop.closed) {
          pop.close()
        }
      }
    },
    toWgs84: function (coord) {
      return Wgs84.from(coord)
    },
    toUtmK: function (coord) {
      const x = coord.x ?? coord.entX
      const y = coord.y ?? coord.entY
      return UtmK.fromXY(x, y)
    },
    calculateDistance: function (coordA, coordB) {
      return coordA.distanceTo(coordB)
    },
  }
})
